import styled from "styled-components";

const PlaylistCardContainer = styled.div`
  background-image: ${(props) => `url("${props.background}") !important`};
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-width: 200px;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.grey};
`;

const PlaylistTitle = styled.p`
  font-size: 18px;
  text-align: center;
  backdrop-filter: blur(10px);
  width: 100%;
  height: 100px;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: white;
`;

export { PlaylistCardContainer, PlaylistTitle };
